import { render, staticRenderFns } from "./LocalDBVerification.vue?vue&type=template&id=cd918524&scoped=true"
import script from "./LocalDBVerification.vue?vue&type=script&lang=js"
export * from "./LocalDBVerification.vue?vue&type=script&lang=js"
import style0 from "./LocalDBVerification.vue?vue&type=style&index=0&id=cd918524&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd918524",
  null
  
)

export default component.exports